import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Question from "../components/question"
import Answer from "../components/answer"
import CommentsList from "../components/comments-list"
import initializeVWO from "../components/vwo"

const MAX_LIKES = 3 

class IndexPage extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      availableLikes: MAX_LIKES
    }
  }

  componentDidMount() {
    initializeVWO()
  }

  likeUpOrDown = ( like ) => {
    const { availableLikes } = this.state
      this.setState({
        availableLikes:  availableLikes + like
      })
  }

  render() {
    const { data } = this.props
    const answers = data.allMarkdownRemark.edges
    const siteUrl = data.site.siteMetadata.siteUrl

    return (
      <Layout location={this.props.location}>
        <Question />
        <h2 className="highlited">
          Top Community Picks
        </h2>
        { answers.map( (answer, index) => (
          <React.Fragment key={`answer-${index}`}>
            <Answer 
              data={ answer.node.frontmatter }
              siteUrl={siteUrl}
              html={answer.node.html}
              isWinner={ index === 0 }
              onLikeUpOrDown={ this.likeUpOrDown }
              hasLikes={ !!this.state.availableLikes} />

            <CommentsList 
              comments={answer.node.frontmatter.comments}
              siteUrl={siteUrl}
              onLikeUpOrDown={ this.likeUpOrDown }
              hasLikes={ !!this.state.availableLikes}
              isWinner={ index === 0 } />
          </React.Fragment>
        ))}
      </Layout>
    )
  }
}

export default IndexPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    allMarkdownRemark(
      filter: {
        fileAbsolutePath: {regex: "\\/answers/"}
      }, 
      sort: {
        fields: [frontmatter___position], order: [ASC]
      }
      ) {
      edges {
        node {
          html
          frontmatter {
            title
            owner
            avatar
            productLink
            productImage
            position
            likes
            stars
            comments {
              date
              name
              avatar
              description
              readMore
              tabs
              likes
            }
            usersAvatars {
              avatar
            }
          }
        }
      }
    }
  }
`